export default "__VITE_ASSET__yjyPMzNN__"